module.exports = __webpack_public_path__ + "static/media/Oluwatoni.b577c168.png";